export default {
  namespaced: true,
  state: {
    error: null,
    is: {
      loading: false,
      drawerOpen: false,
      compareDrawerOpen: false,
      compareDrawerSelectorOpen: false,
      dev: process.env.NODE_ENV === 'development'
    },
    settings: {
      featureCollapse: {}
    }
  },
  mutations: {
    SET_LOADING (state, payload) {
      state.is.loading = payload
    },
    SET_ERROR (state, payload) {
      state.error = payload
    },
    CLEAR_ERROR (state) {
      state.error = null
    },
    CLOSE_COMPARE_DRAWER (state) {
      state.is.compareDrawerOpen = false
    },
    CLOSE_COMPARE_DRAWER_SELECTOR (state) {
      state.is.compareDrawerSelectorOpen = false
    },
    OPEN_COMPARE_DRAWER_SELECTOR (state) {
      state.is.compareDrawerSelectorOpen = true
    },
    TOGGLE_DRAWER (state) {
      state.is.drawerOpen = !state.is.drawerOpen
      // state.is = Object.assign({}, state.is, {drawerOpen: !state.is.drawerOpen})
    },
    TOGGLE_COMPARE_DRAWER (state) {
      state.is.compareDrawerOpen = !state.is.compareDrawerOpen
    },
    TOGGLE_COMPARE_DRAWER_SELECTOR (state) {
      state.is.compareDrawerSelectorOpen = !state.is.compareDrawerSelectorOpen
    },
    TOGGLE_FEATURE (state, featureToToggle) {
      state.settings.featureCollapse[featureToToggle] =
        !state.settings.featureCollapse[featureToToggle]
    },
    SET_FEATURE_SECTION_SETTINGS (state, featureSettings) {
      state.settings.featureCollapse = featureSettings
    }
  },
  actions: {
    clearError ({ commit }) {
      commit('CLEAR_ERROR')
    },
    closeCompareDrawer ({ commit, state }) {
      if (state.is.compareDrawerOpen) {
        commit('CLOSE_COMPARE_DRAWER')
      }
    },
    closeCompareDrawerSelector ({ commit, state }) {
      if (state.is.compareDrawerSelectorOpen) {
        commit('CLOSE_COMPARE_DRAWER_SELECTOR')
      }
    },
    openCompareDrawerSelector ({ commit }) {
      commit('OPEN_COMPARE_DRAWER_SELECTOR')
    },
    toggleDrawer ({ commit }) {
      commit('TOGGLE_DRAWER')
    },
    toggleCompareDrawer ({ commit }) {
      commit('TOGGLE_COMPARE_DRAWER')
    },
    toggleCompareDrawerSelector ({ commit }) {
      commit('TOGGLE_COMPARE_DRAWER_SELECTOR')
    },
    toggleFeature ({ commit, state }, featureKey) {
      commit('TOGGLE_FEATURE', featureKey)
    },
    setFeatureSectionSettings ({ commit, state }, featureSettingsFromFirebase) {
      commit('SET_FEATURE_SECTION_SETTINGS', featureSettingsFromFirebase)
    }
  },
  getters: {
    error: state => state.error,
    loading: state => state.is.loading,
    settings: state => state.settings,
    statuses: state => state.is
  }
}



// WEBPACK FOOTER //
// ./src/store/shared.js